$( document ).ready(function() {
  objectFitImages();
});
